import { runCleanup } from './cleanup.js'
import { scrollToHash } from './goTo.js'

function transitions() {
  // URLs que deben excluirse de las transiciones
  const excludedPaths = [
    '/pedido',
    '/customizer',
    // Agregar más rutas aquí si es necesario
    // '/otra-ruta',
  ]

  if (navigation.addEventListener) {
    navigation.addEventListener('navigate', (event) => {
      // Verificar si la URL es externa
      if (!event.destination.url.includes(document.location.origin)) {
        return;
      }

      const destUrl = new URL(event.destination.url)
      const currUrl = new URL(document.location.href)
      const destinationPath = destUrl.pathname
      const isExcluded = excludedPaths.some(path => destinationPath.includes(path))

      if (isExcluded) {
        // DEBUG: console.log(`🚫 Transición omitida para: ${destinationPath}`)
        // No interceptar, dejar que la navegación continúe normalmente
        return;
      }

      // Misma ruta: solo cambia el hash (submenu → #equipo / #testimonios).
      // No refetch ni View Transition: Lenis maneja el scroll.
      const isSameDocument =
        destUrl.pathname === currUrl.pathname &&
        destUrl.search === currUrl.search

      if (isSameDocument) {
        if (!destUrl.hash || !event.canIntercept) return

        event.intercept({
          handler () {
            scrollToHash(destUrl.hash, { delay: 50 })
          },
          scroll: 'manual'
        })
        return
      }

      if (!event.canIntercept) return

      // Solo interceptar si NO está excluida
      event.intercept({
        async handler() {
          // Fetch sin el hash: el fragmento no se envía al servidor
          const fetchUrl = destUrl.origin + destUrl.pathname + destUrl.search
          const response = await fetch(fetchUrl);
          const text = await response.text();
          const pendingHash = destUrl.hash

          const transition = document.startViewTransition(() => {
            // Desmontar todo lo que los módulos instalaron sobre el DOM actual
            // ANTES de destruirlo. Debe correr con los nodos todavía vivos
            // (SplitType.revert(), swiper.destroy(), etc. los necesitan).
            runCleanup();

            // Parsear HTML usando DOMParser
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            
            // Extraer y actualizar atributos del body
            const newBody = doc.querySelector('body');
            if (newBody) {
              document.body.className = newBody.className;
              document.body.dataset.page = newBody.dataset.page;
            }
            
            // Agregar clase de transición después de actualizar el body
            document.body.classList.add('page-transitioning');
            
            // Extraer contenido del transition-wrapper
            const newWrapper = doc.querySelector('.transition-wrapper');
            const wrapper = document.querySelector('.transition-wrapper');

            if (newWrapper && wrapper) {
              wrapper.innerHTML = newWrapper.innerHTML;
              
              // Re-ejecutar scripts inline del nuevo contenido
              const scripts = wrapper.querySelectorAll('script');
              // console.log(`Re-ejecutando ${scripts.length} scripts...`);
              
              scripts.forEach((script, index) => {
                // Pequeño delay entre scripts para evitar conflictos
                setTimeout(() => {
                  const newScript = document.createElement('script');
                  
                  // Copiar atributos (type, src, etc.)
                  Array.from(script.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                  });
                  
                  // Copiar contenido si es inline
                  if (!script.src) {
                    newScript.textContent = script.textContent;
                  }
                  
                  // Reemplazar script antiguo con nuevo para forzar ejecución
                  script.parentNode.replaceChild(newScript, script);
                  // console.log(`Script ${index + 1} ejecutado`);
                }, index * 10);
              });
              
            }

            // Actualizar título
            const newTitle = doc.querySelector('title');
            if (newTitle) {
              document.title = newTitle.textContent;
            }
          });

          const reinit = () => {
            window.scrollTo(0, 0);

            // Pequeño delay para asegurar que scripts se ejecuten después del DOM
            setTimeout(() => {
              // Disparar evento para re-inicializar módulos.
              // pendingHash: el scroll a ancla corre DESPUÉS de que Lenis
              // resetee a 0 en page-transition-complete.
              window.dispatchEvent(new CustomEvent('page-transition-complete', {
                detail: { hash: pendingHash || '' }
              }));
            }, 50);
          };

          // `ready` se rechaza cuando el navegador omite la animación (pestaña
          // oculta, reduced-motion, transición interrumpida). No lo usamos,
          // pero hay que consumirlo o queda una promesa rechazada sin handler
          // que se reporta como excepción en cada navegación.
          transition.ready.catch(() => {})

          // updateCallbackDone (no `ready`) porque siempre se resuelve una vez
          // aplicado el nuevo DOM. `ready` se RECHAZA si el navegador omite la
          // animación —pestaña oculta, reduced-motion, transición interrumpida—
          // y en ese caso la página quedaba sin re-inicializar tras el cleanup.
          transition.updateCallbackDone.then(reinit, reinit);
        },
        scroll: 'manual'
      });

    });
  }
}

export default transitions
